<template>
  <div id="app">
    <!-- <router-view/> -->
    <keep-alive  include="business,businessSearch,businessClassifyList">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      codeInfo:''
    }
  },
  created() {
    this.codeInfo = this.GLOBAL.getQueryString('codeInfo')
    // 进入页面执行
    // 记录当前时间并转成时间戳
    const now = new Date().getTime();
    // 从缓存中获取用户上次退出的时间戳
    const leaveTime = parseInt(localStorage.getItem('leaveTime'), 10);
    // 判断是否为刷新，两次间隔在5s内判定为刷新操作
    const refresh = (now - leaveTime) <= 10000;
    if (refresh) {
      // 刷新
    } else {
      if (this.codeInfo == null) {
        // 重新登录
        localStorage.removeItem('token')
        localStorage.removeItem('userData')
      }
    }
    // 退出当前页面执行
    window.onunload = function(e){ // ios 不支持 window.onbeforeunload()
      // 将退出时间存于localstorage中
      localStorage.setItem('leaveTime', new Date().getTime());
    }
  },
  
}
</script>

<style>
@import "./assets/css/common.css";
  body {
    margin: 0;
  }
  .article_detail .article_con .article_con_box img{
  max-width: 100%!important;
  height: auto!important;
}
.article_detail .article_con .article_con_box span{
  display: inline;
}
#app{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue